import { gql } from "@apollo/client";

export const DASHBOARD_INDICATORS_LIST_QUERY = gql`
  query dashboardIndicatorsList($userId: Int!, $groupName: String!, $dashboardIds: [Int!], $lang: String!) {
    dashboardIndicators(userId: $userId, groupName: $groupName, dashboardIds: $dashboardIds, lang: $lang) {
      id
      name
      indicators(userId: $userId, groupName: $groupName) {
        id
        name
        title
        type
        pie {
          id
          value
          label
          amount
          financedValue
        }
        graphic {
          value
          month
          type
          status
        }
      }
    }
  }
`;
